module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.documents.length === 0) ? _c('div', {
    staticClass: "row top-margin"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.documents.length > 0) ? _c('div', {
    class: {
      'table-fixed-header--md': _vm.documents.length > 6,
        'table-responsive': true,
        'bottom-margin': true,
        'overflow-y-off': true,
    }
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.documents), function(document) {
    return _c('tr', {
      key: document.Key
    }, [_c('td', {
      staticClass: "file file-name name-data",
      on: {
        "click": function($event) {
          _vm.openDocument(document)
        }
      }
    }, [_c('i', {
      staticClass: "icon fa fa-file-text-o"
    }), _c('a', {
      attrs: {
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(document.Key))])]), _vm._v(" "), _c('td', {
      staticClass: "file-updated-date text-left uploaded-data"
    }, [_vm._v("\n            " + _vm._s(_vm.formatDate(!!document.Head &&
      !!document.Head.Metadata &&
      !!document.Head.Metadata.uploaded_at ? document.Head.Metadata.uploaded_at : document.LastModified)) + "\n          ")])])
  }))])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "alert alert-info alert-dismissible",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n        No documents were found.\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "text-left name-head"
  }, [_vm._v("Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-left uploaded-head"
  }, [_vm._v("Uploaded on")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-386f3b9c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DocumentTabView/DocumentView.vue
// module id = 2137
// module chunks = 1